import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        color: '#202020',
        backgroundColor: '#fff',
        height: '53px'
    },
    hover: {
        '&:hover': {
            color: '#202020',
            backgroundColor: '#F6F6F6'
        }
    },
    selected: {
        color: '#202020',
        backgroundColor: '#F6F6F6'
    },
    InstructionOptionSelectWrapper: {
        display: 'flex',
        flexGrow: 1,
        '&:hover': {
            backgroundColor: '#F6F6F6',
            color: '#000'
        },
        '&:first-child > div': { borderTop: 'none' }
    },
    InstructionOptionSelect: {
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        margin: '0 10px',
        cursor: 'default',
        '&__left': { flexGrow: 1 },
        '&__right': {
            paddingLeft: '1rem',
            paddingRight: '1rem',
            borderLeft: '1px solid #E4E4E4'
        }
    },
    InstructionOption: {
        fontSize: '14px',
        lineHeight: '1rem'
    }
}));